import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './Remedies.css';

export default function Remedies() {







  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);





  return (
    <>
    
    
    <div><Navbar/></div>
    
    
    
    
    <section id="remedies">
    <div class="container">
      <h1 class="section-title">Astrological Remedies for Life Challenges</h1>

      
      <div class="remedy-card">
        <h2 class="remedy-title">1. Remedies for Financial Stability</h2>
        <p class="root-causes">Root Causes:</p>
        <ul>
          <li>Past life karma affecting wealth accumulation.</li>
          <li>Planetary weaknesses or malefic influences, particularly Venus, Jupiter, and Saturn.</li>
          <li>Ancestral debts or curses.</li>
        </ul>
        <p class="prescribed-remedies">Prescribed Remedies:</p>
        <ul>
          <li>Visit Lakshmi temples on Fridays and offer lotus flowers, sweets, and milk to Goddess Lakshmi.</li>
          <li>Perform Kubera Pooja during Diwali to attract wealth.</li>
          <li>Donate food, clothes, or money to orphans and the underprivileged on Fridays and Saturdays.</li>
          <li>Chant "Om Shreem Mahalakshmiyei Namah" 108 times daily.</li>
          <li>Observe fasts on Thursdays to strengthen Jupiter for better financial luck.</li>
          <li>Install Kubera Yantra at home and wear yellow sapphire (Pukhraj) after consultation.</li>
        </ul>
        <p class="benefits">Benefits:</p>
        <ul>
          <li>Eliminates financial blockages and attracts wealth.</li>
          <li>Brings stability in income and reduces unnecessary expenses.</li>
        </ul>
      </div>

      
      <div class="remedy-card">
        <h2 class="remedy-title">2. Remedies for Health Issues</h2>
        <p class="root-causes">Root Causes:</p>
        <ul>
          <li>Afflictions by malefic planets like Rahu, Ketu, and Saturn.</li>
          <li>Karmic debts resulting in chronic diseases.</li>
          <li>Negative energies or curses impacting health.</li>
        </ul>
        <p class="prescribed-remedies">Prescribed Remedies:</p>
        <ul>
          <li>Perform Dhanvantari Homa to invoke the blessings of the divine healer Lord Dhanvantari.</li>
          <li>Conduct Navagraha Shanti Pooja to pacify afflicted planets.</li>
          <li>Offer neem leaves, turmeric, and tulsi to deities known for healing.</li>
          <li>Chant "Om Namo Bhagavate Vasudevaya Dhanvantarye Amritakalasha Hastaya Namah" for 108 days.</li>
          <li>Use traditional ayurvedic remedies guided by astrologers.</li>
          <li>Donate medicines and provide food to the sick on Tuesdays.</li>
        </ul>
        <p class="benefits">Benefits:</p>
        <ul>
          <li>Alleviates chronic illnesses.</li>
          <li>Promotes physical and mental well-being.</li>
        </ul>
      </div>

      
      <div class="remedy-card">
        <h2 class="remedy-title">3. Remedies for Relationship Harmony</h2>
        <p class="root-causes">Root Causes:</p>
        <ul>
          <li>Misalignment of Venus, Moon, or Mars in the birth chart.</li>
          <li>Past life issues creating rifts in relationships.</li>
          <li>Lack of spiritual alignment in partnerships.</li>
        </ul>
        <p class="prescribed-remedies">Prescribed Remedies:</p>
        <ul>
          <li>Perform Venus Shanti to strengthen love and harmony.</li>
          <li>Offer white flowers to the Moon on Mondays for emotional balance.</li>
          <li>Recite "Om Shukraya Namah" to strengthen Venus.</li>
          <li>Chant "Om Som Somaya Namah" for a peaceful mind.</li>
          <li>Feed birds or donate white-colored items on Fridays.</li>
          <li>Observe fasts on Mondays for marital happiness.</li>
          <li>Conduct Rudrabhishek to Lord Shiva for removing marital discord.</li>
        </ul>
        <p class="benefits">Benefits:</p>
        <ul>
          <li>Strengthens family bonds and marital relationships.</li>
          <li>Resolves misunderstandings and brings peace.</li>
        </ul>
      </div>

      
      <div class="remedy-card">
        <h2 class="remedy-title">4. Remedies for Career Growth</h2>
        <p class="root-causes">Root Causes:</p>
        <ul>
          <li>Weak Mercury or Sun leading to stagnation.</li>
          <li>Planetary doshas like Rahu-Ketu afflicting professional houses.</li>
          <li>Negative karma affecting career growth.</li>
        </ul>
        <p class="prescribed-remedies">Prescribed Remedies:</p>
        <ul>
          <li>Perform Surya Namaskar daily and offer water to the Sun.</li>
          <li>Conduct Mercury Pooja to enhance intellect and communication skills.</li>
          <li>Chant "Om Bhaskaray Namah" for career success.</li>
          <li>Recite "Om Budhaya Namah" for clarity in decision-making.</li>
          <li>Wear emerald or ruby based on astrological advice.</li>
          <li>Offer prayers to Lord Ganesha every Wednesday for removing obstacles.</li>
        </ul>
        <p class="benefits">Benefits:</p>
        <ul>
          <li>Opens new career opportunities.</li>
          <li>Enhances confidence and decision-making skills.</li>
        </ul>
      </div>

      
      <div class="remedy-card">
        <h2 class="remedy-title">5. Remedies for Childbirth Challenges</h2>
        <p class="root-causes">Root Causes:</p>
        <ul>
          <li>Karmic issues from past lives impacting progeny.</li>
          <li>Affliction in the 5th house of the horoscope.</li>
          <li>Weak Jupiter and Venus.</li>
        </ul>
        <p class="prescribed-remedies">Prescribed Remedies:</p>
        <ul>
          <li>Perform Santana Gopala Pooja for progeny blessings.</li>
          <li>Conduct Ashlesha Bali rituals to nullify serpentine curses.</li>
          <li>Chant "Om Devakisutaya Vidmahe Vasudevaya Dheemahi Tanno Krishna Prachodayat" 108 times.</li>
          <li>Offer prayers to Lord Subramanya and Goddess Durga.</li>
          <li>Donate sweets or milk to children on Thursdays.</li>
        </ul>
        <p class="benefits">Benefits:</p>
        <ul>
          <li>Resolves karmic issues and blesses with healthy progeny.</li>
        </ul>
      </div>

            <div class="remedy-card">
        <h2 class="remedy-title">6. Remedies for Overcoming Debts</h2>
        <p class="root-causes">Root Causes:</p>
        <ul>
          <li>Affliction of the 6th house or Saturn.</li>
          <li>Weak financial planets like Jupiter or Mercury.</li>
        </ul>
        <p class="prescribed-remedies">Prescribed Remedies:</p>
        <ul>
          <li>Donate black sesame seeds, mustard oil, or iron on Saturdays.</li>
          <li>Recite "Om Shan Shanishcharaya Namah" to pacify Saturn.</li>
          <li>Conduct Rahu-Ketu dosha remedies to remove financial burdens.</li>
          <li>Feed the poor or animals like crows on Saturdays.</li>
        </ul>
        <p class="benefits">Benefits:</p>
        <ul>
          <li>Gradually eliminates debt and improves financial stability.</li>
        </ul>
      </div>

      
      <div class="remedy-card">
        <h2 class="remedy-title">7. Remedies for Protection from Enemies and Negative Energies</h2>
        <p class="root-causes">Root Causes:</p>
        <ul>
          <li>Malefic influences of Mars and Rahu.</li>
          <li>Karmic debts leading to enmity.</li>
        </ul>
        <p class="prescribed-remedies">Prescribed Remedies:</p>
        <ul>
          <li>Chant "Om Hanumate Namah" for courage and protection.</li>
          <li>Recite "Om Saravanabhava Namah" for overcoming obstacles.</li>
          <li>Perform Sudarshana Homa for protection from adversities.</li>
          <li>Offer black grams and sesame seeds to Saturn on Saturdays.</li>
        </ul>
        <p class="benefits">Benefits:</p>
        <ul>
          <li>Nullifies negative influences and ensures safety.</li>
        </ul>
      </div>

      
      <div class="remedy-card">
        <h2 class="remedy-title">8. Remedies for Mental Peace</h2>
        <p class="root-causes">Root Causes:</p>
        <ul>
          <li>Planetary afflictions affecting the mind.</li>
          <li>Unresolved karmic issues causing stress.</li>
        </ul>
        <p class="prescribed-remedies">Prescribed Remedies:</p>
        <ul>
          <li>Chant "Om Namah Shivaya" for peace and spiritual growth.</li>
          <li>Practice meditation daily to balance energy centers.</li>
          <li>Donate to mental health causes or help the needy.</li>
        </ul>
        <p class="benefits">Benefits:</p>
        <ul>
          <li>Brings emotional balance and inner peace.</li>
        </ul>
      </div>

    </div>
  </section>
    
    
    
    
    
    
    
    {/* <div><Footer/></div>
     */}
    
    </>
  )
}
